import { uuid } from "vue-uuid";

export class Petition {
  constructor(
    token = "",
    table = "",
    type = 0,
    paginate = 10,
    condition = "",
    items = [],
    filters = [],
    transaction = false
  ) {
    this.token = token || uuid.v4();
    this.table = table;
    this.type = type;
    this.condition = condition;
    this.items = items;
    this.filters = filters;
    this.transaction = transaction;
    this.paginate = paginate;
  }

  add_session(_item) {
    this.session.push(_item);
  }

  add_item(_name = "", _value = null, _type = "string", _action = null) {
    if ((_name.length != 0 && _value != "" && _value != null) || (_type == "string" && _value != null)) {
      this.items.push({ name: _name, value: _value, type: _type, action: _action });
    }

    /*if(_type == "string"){
      if(_value != null && _name.length != 0) {
        this.items.push({ name: _name, value: _value, type: _type, action: _action });
      } else {
        this.items.push({ name: _name, value: "", type: _type, action: _action });
      }
    } else if(_type == "int"){
      if(_name.length != 0 && _value != null) {
        this.items.push({ name: _name, value: _value, type: _type, action: _action });
      } else {
        this.items.push({ name: _name, value: null, type: _type, action: _action });
      }
    }*/
  }

  add_itemNulo(_name = "", _value = null, _type = "string", _action = null) {
    this.items.push({ name: _name, value: _value, type: _type, action: _action });
  }

  add_itemFilter(_name = "", _value = null, _type = "string", _action = null) {
    if(_name.length != 0 && (_value == null || _value == "")) {
      this.items.push({ name: _name, value: "null", type: "int", action: _action });
    } 
    else if(_name.length != 0 && _value != null)
    {
      this.items.push({ name: _name, value: _value, type: _type, action: _action });
    }
  }

  add_itemWithNulo(_name = "", _value = null, _type = "string", _action = null) {
    if(_value == "" || _value == null) {
      this.items.push({ name: _name, value: "null", type: "int", action: _action });
    } else {
      this.items.push({ name: _name, value: _value, type: _type, action: _action });
    }
  }

  // add_itemFilter(_name = "", _value = null, _type = "string", _action = null) {
  //   if(_value != "" && _value != null) {
  //     this.items.push({ name: _name, value: _value, type: _type, action: _action });
  //   } 
  // }

  add_itemSelect(_name = "", _value = null, _type = "string", _action = null) {
    if(_value == "" || _value == null) {
      this.items.push({ name: _name, value: "0", type: _type, action: _action });
    } else if ((_name.length != 0 && _value != "" && _value != null) || (_type == "string" && _value != null)) {
      this.items.push({ name: _name, value: _value, type: _type, action: _action });
    }

    /*if(_type == "string"){
      if(_value != null && _name.length != 0) {
        this.items.push({ name: _name, value: _value, type: _type, action: _action });
      } else {
        this.items.push({ name: _name, value: "", type: _type, action: _action });
      }
    } else if(_type == "int"){
      if(_name.length != 0 && _value != null) {
        this.items.push({ name: _name, value: _value, type: _type, action: _action });
      } else {
        this.items.push({ name: _name, value: null, type: _type, action: _action });
      }
    }*/
  }

  add_value(_item = {}) {
    this.items.push(_item);
  }

  add_items(_items = []) {
    _items.forEach((item) => {
      this.items.push(item);
    });
  }
}
